import React from 'react';

const initialState = {
  isMobile: false,
};

const PageContext = React.createContext(initialState);

export default PageContext;